import { useMap } from "@vis.gl/react-google-maps";
import { oneOnboardingApi } from "libs/api";
import type { PropertyData } from "libs/codegen/property-onboarding";
import { useCallback } from "react";
import { useFormContext } from "react-hook-form";
import { useParams } from "router";
import { useFormController } from "../form/useFormController";
import type { GoogleLatLngLiteral } from "./types";

export const useMarkerController = () => {
    const map = useMap();
    const { lang } = useParams("/:lang/list-my-property/onboard/:propertyId/location");
    const { setValue, getValues } = useFormContext<PropertyData>();

    const { value: latitude, setValue: setLatitude } = useFormController("latitude");
    const { value: longitude, setValue: setLongitude } = useFormController("longitude");

    const movePin = useCallback(
        (latLng: Partial<GoogleLatLngLiteral>, dropdown = false) => {
            if (typeof latLng.lng === "number" && typeof latLng.lat === "number") {
                // get options result from api
                oneOnboardingApi.getGeocode(lang, getValues("country.id"), latLng.lat, latLng.lng).then(({ data }) => {
                    // if it's a dropdown, then update just areaId
                    if (!dropdown) {
                        setValue("country", data.country);
                        setValue("state", data.state);
                        setValue("city", data.city);
                    }
                    setValue("areaId", data.areaId);
                });

                // pan camera
                setLatitude(latLng.lat);
                setLongitude(latLng.lng);
                map.panTo({
                    lat: latLng.lat,
                    lng: latLng.lng,
                });
            }
        },
        [map],
    );

    return {
        pin: {
            lat: latitude,
            lng: longitude,
        },
        movePin,
    };
};
